var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 22,
    width: 30,
    height: 30,
    transform: "rotate(-45 0.787109 22)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2711_31262",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2711_31262",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA50lEQVR4nO3UsRHCAAwEQVdztdF/AyaFzJnfsDujBnQjHQcAAAAAAADAc/U6vwZB+ORCxuRlbUmQLQmyJUG2JMiWBNmSIFsSZEuCbEmQLQmyJUG2JMiWBNmSIFsSZEuCbEmQLQmyJUG2JMiWBNmSIFsSZEuCbEmQLQlybTH/NnPuXkiCCJILOW+/hMe8rLtkMVsSZEuCbEmQLQmyJUG2JMiWBNmSIFsSZEuCbEmQLQmyJUG2JMiWBNmSIFsSZEuCbEmQLQmyJUG2JMiWBNmSIFsSZEuCbEmQLQmyJUEAAAAAAACA40e8AUN+AV6hyW4XAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterClose);
export default __webpack_public_path__ + "static/media/footer-close.9d7a1eb816a8049fdba5e7b680ce2689.svg";
export { ForwardRef as ReactComponent };